import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchBankList,
  fetchBankListSuccess,
  fetchBankListFailure,
} from "../slices/bankListSlice";

const fetchBankListAPI = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/v1/banks-list`);

  if (!res.ok) throw new Error("Fetch failed");

  const data = await res.json();
  return data?.data || [];
};

function* handleFetchBankList() {
  try {
    const data = yield call(fetchBankListAPI);
    yield put(fetchBankListSuccess(data));
  } catch (error) {
    yield put(fetchBankListFailure(error.message));
  }
}

export function* watchBankListSaga() {
  yield takeLatest(fetchBankList.type, handleFetchBankList);
}
